import React, { useEffect, useRef, useState } from "react";
import styles from "./SuccessSection.module.css";



const stories = [
  { id: 1, name: "LIL PUMP", info: " Massano is an up-and-coming artist within the melodic techno scene. He has already achieved impressive success at only 23-years-old.", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/LIL%20PUMP.jpg' },
  { id: 2, name: "Massano", info: " Massano is an up-and-coming artist within the melodic techno scene. He has already achieved impressive success at only 23-years-old.", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/MASSONA.jpg' },
  { id: 3, name: "Rodolphe Manoukian", info: " Massano is an up-and-coming artist within the melodic techno scene. He has already achieved impressive success at only 23-years-old.", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/Rodolphe%20Manoukian_s.jpg' },
  { id: 4, name: "SON OF SON", info: " Massano is an up-and-coming artist within the melodic techno scene. He has already achieved impressive success at only 23-years-old.", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/SON%20OF%20SON.webp' },
  { id: 5, name: "Alec Monopoly", info: " Massano is an up-and-coming artist within the melodic techno scene. He has already achieved impressive success at only 23-years-old.", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/Alec_Monopoly.jpg' },
  { id: 5, name: "Vidojean", info: " Massano is an up-and-coming artist within the melodic techno scene. He has already achieved impressive success at only 23-years-old.", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/Vidojean.jpg' },
];

const SuccessSection = () => {
  const [index, setIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(4);
  const timeoutRef = useRef(null);

  // Infinite scroll preparation
  const extendedStories = [...stories, ...stories];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) setVisibleSlides(1.2);
      else if (window.innerWidth < 900) setVisibleSlides(2);
      else if (window.innerWidth < 1200) setVisibleSlides(3);
      else setVisibleSlides(4);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setIndex((prevIndex) => 
        prevIndex === stories.length - 1 ? 0 : prevIndex + 1
      );
    }, 2500);

    return () => resetTimeout();
  }, [index]);

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>Our Success Stories</h2>

        <div className={styles.carousel}>
          <div 
            className={styles.track}
            style={{ 
              transform: `translateX(${-index * (100 / visibleSlides)}%)`,
              transition: 'transform 0.8s cubic-bezier(0.2, 0, 0.2, 1)'
            }}
          >
            {extendedStories.map((story, i) => (
              <div 
                key={i} 
                className={styles.slide}
                style={{ width: `${100 / visibleSlides}%` }}
              >
                <div className={styles.imageBox}>
                  <img src={story.img} alt={story.name} />
                </div>
                <div className={styles.info}>
                  <h3>{story.name}</h3>
                  {/* <p>{story.info}</p> */}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation Dots */}
        <div className={styles.dots}>
          {stories.map((_, i) => (
            <span
              key={i}
              className={index === i ? styles.activeDot : ""}
              onClick={() => setIndex(i)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessSection;